import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useSelector } from 'react-redux';
import actionsApp from '~/redux/app/actions';
import { useDispatch } from 'react-redux';
import CustomButton from '~/src/components/CustomButton';
import CustomButtonOutlined from '~/src/components/CustomButtonOutlined';
import Text from '~/src/components/Typography/Text';

import {
    COOKIE1,
    COOKIE2,
    COOKIE_QRCODE1_DURATION,
    COOKIE_QRCODE2_DURATION,
} from '~/src//config/constants';
import Cookies from 'js-cookie';
import actionsCommon from '~/redux/common/actions';
import translateMsg from '~/src/lib/translateMsg';
import Image from 'next/image';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function App(props) {
    const business = useSelector((state) => state.business);

    //const cookieQrcodeExpireAlert = useSelector((state) => state.app.cookieQrcodeExpireAlert);
    const dispatch = useDispatch();

    //console.log('cdcdcdcd');
    //console.log(cookieQrcodeExpireAlert);

    const handleClose = () => {
        //dispatch(actionsApp.showCookieQrcodeExpireAlert(false));
    };

    const title = `${translateMsg('webapp', 'pwa_ui__ru_always_table')} ${
        props.title
    } ?`;

    return (
        <div>
            <Dialog
                open={true}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <div style={{ textAlign: 'center', padding: 20 }}>
                    <Image
                        unoptimized
                        src="/img/waiter.svg"
                        width="75"
                        height="75"
                        alt=""
                    />
                </div>

                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <div style={{ marginTop: 20, marginBottom: 20 }}>
                        <CustomButton
                            business={business}
                            fullWidth={true}
                            variant="contained"
                            onClick={(event) => {
                                event.preventDefault();
                                Cookies.set(COOKIE2, Cookies.get(COOKIE1), {
                                    expires: COOKIE_QRCODE2_DURATION / 86400,
                                });
                                dispatch(
                                    actionsApp.setQrcodeInfo(
                                        Cookies.get(COOKIE1),
                                    ),
                                );
                                handleClose();
                            }}
                        >
                            <Text variant="body1">
                                {translateMsg(
                                    'webapp',
                                    'pwa_ui__at_the_table_continue_ordering',
                                )}
                            </Text>
                        </CustomButton>
                    </div>

                    <CustomButtonOutlined
                        business={business}
                        fullWidth={true}
                        variant="contained"
                        onClick={(event) => {
                            event.preventDefault();
                            Cookies.remove(COOKIE1);
                            Cookies.remove(COOKIE2);
                            dispatch(actionsApp.setQrcodeInfo(false));
                            console.log(
                                'RESET CART FROM src/components/CookieWatcher/Dialog.jsx',
                            );
                            dispatch(actionsCommon.resetCart());
                            handleClose();
                        }}
                    >
                        <Text variant="body1">
                            {translateMsg('webapp', 'pwa_ui__no_longer_table')}
                        </Text>
                    </CustomButtonOutlined>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default App;
